<template>
    <el-dialog :visible.sync="DialogVisible">
        <div class="header flex jcb">
            <span class="fs18 color_333 bold">互联网医生工作平台处方</span>
        </div>
        <div class="mt10">
            <div class="flex"><img src="../../../assets/icon/prescription/medicine.png" alt=""><span class="fs16 bold ml10">西药药品</span></div>
            <div class="flex column bb">
                <div class="flex column pt10 pb10" :class="{btd:index>0}" v-for="(item,index) in bizList">
                    <div class="flex jcb">
                        <div>
                            <span>{{item.itemname}}</span><span class="ml20">{{`${item.spec}`}}</span>
                        </div>
                        <span>￥{{item.price}}</span>
                    </div>
                    <div class="flex jcb" v-if="item.adderss">
                        <div>
                            <span>产地：</span><span>{{item.adderss}}</span>
                        </div>
                    </div>
                    <div class="flex jcb">
                        <div>
                            <span>用法用量：</span><span>{{item.usage}}</span>
                        </div>
                        <span>x {{item.plasters}}</span>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "wlmz-biz-detail",
        data(){
            return {
                DialogVisible:false,
                bizList:[]
            }
        },
        methods:{
            show(list = []){
                this.bizList = list;
                this.DialogVisible = true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .bbd{
        border-bottom: 1px #E5E5E5 dashed;
    }
    .btd{
        border-top: 1px #E5E5E5 dashed;
    }
</style>